module.exports = __webpack_public_path__ + "static/media/fundacja-psia-krew.964a1a03.jpg";